import React from "react";

export default function Terms() {
  return (
    <section className="terms">
      <div className="auto__container">
        <div className="terms__inner">
          <div className="terms__inner-title">
            <p className="sm">Proxium</p>
            <h3>Terms & Conditions</h3>
            <p className="sm">Last Updated: April 9th, 2024</p>
          </div>
          <p>
            BY CLICKING “I AGREE,” CHECKING A RELATED BOX TO SIGNIFY YOUR
            ACCEPTANCE, USING ANY OTHER ACCEPTANCE PROTOCOL PRESENTED THROUGH
            THE SERVICE (AS DEFINED BELOW) OR OTHERWISE AFFIRMATIVELY ACCEPTING
            THESE TERMS AND CONDITIONS, YOU ACKNOWLEDGE THAT YOU HAVE READ,
            ACCEPTED, AND AGREED TO BE BOUND BY ProxiumAGREEMENT. IF YOU DO NOT
            AGREE TO THESE TERMS AND CONDITIONS, DO NOT CREATE AN ACCOUNT OR USE
            THE SERVICE. YOU HEREBY GRANT AGENCY AUTHORITY TO ANY PARTY WHO
            CLICKS ON THE “I AGREE” BUTTON OR OTHERWISE INDICATES ACCEPTANCE TO
            THESE TERMS AND CONDITIONS ON YOUR BEHALF.
            <br />
            <br />
            ARBITRATION NOTICE: UNLESS YOU TIMELY OPT-OUT OF ARBITRATION IN
            ACCORDANCE WITH THESE TERMS AND CONDITIONS, YOU AGREE THAT DISPUTES
            BETWEEN YOU AND US OR YOU AND THE MEDICAL GROUPS OR PROVIDERS
            ARISING OUT OF OR RELATED TO THESE TERMS AND CONDITIONS OR THE
            SERVICE WILL BE RESOLVED BY BINDING, INDIVIDUAL ARBITRATION AND YOU
            WAIVE YOUR RIGHTS TO A JURY TRIAL AND TO PARTICIPATE IN A CLASS
            ACTION LAWSUIT OR CLASS-WIDE ARBITRATION, AS FURTHER SET FORTH
            BELOW. WE EXPLAIN SOME EXCEPTIONS AND HOW YOU CAN OPT OUT OF
            ARBITRATION BELOW.
            <br />
            <br />
            IF YOU HAVE A MEDICAL EMERGENCY, SEEK IN-PERSON EMERGENCY CARE
            IMMEDIATELY OR DIAL 911. THE SERVICE IS NOT APPROPRIATE FOR ALL
            MEDICAL CONDITIONS OR CONCERNS. TProxiumAGREEMENT IS SUBJECT TO CHANGE
            AS PROVIDED HEREIN.
            <br />
            <br />
            Proxium and/or its subsidiaries (collectively, “Proxium,” “we,” or “us”)
            owns and operates the websites located at <u>www.Proxium.com</u> and
            may have previously, now or in the future own and/or operate a Proxium
            mobile application (collectively, the “Platform”). Your access and
            use of the Platform, any part thereof, or anything associated
            therewith, including its content (“Content”), any products or
            services provided through the Platform or otherwise by Proxium, and
            any affiliated website, software or application owned or operated by
            Proxium (collectively, including the Platform and the Content, the
            “Service”) are governed by these Terms and Conditions (“Terms and
            Conditions” or “Agreement”).
            <br />
            <br />
            Please read tProxiumAgreement carefully because it sets forth the
            important terms you will need to know about the Service. In
            tProxiumAgreement, the terms “you” and “yours” refer to the person
            using the Service, or in the case of a use of the Service by or on
            behalf of a minor, “you” and “yours” refer to and include (i) the
            parent or legal guardian who provides consent to the use of the
            Service by such minor or uses the Service on behalf of the minor;
            and (ii) the minor for whom consent is being provided or on whose
            behalf the Service is being utilized. Please see the “Limited Use
            and Availability” Section of tProxiumAgreement for more information
            regarding use of the Service by minors and applicable limitations on
            such use.
            <br />
            <br />
            Notwithstanding the foregoing, the Service is not intended for
            individuals under the age of thirteen (13) and individuals under the
            age of thirteen (13) are prohibited from using all or any part of
            the Service or entering into tProxiumAgreement, even if a parent or
            legal guardian would be willing to provide consent to use of the
            Service or tProxiumAgreement. Please contact us at support@Proxium.com
            if you are a parent or legal guardian of an individual under the age
            of eighteen (18) who you believe has used the Service without your
            consent.
            <br />
            <br />
            <b>
              Acceptance of Terms and Conditions
              <br />
            </b>
            Your access to and use of the Service is subject to tProxiumAgreement,
            as well as all applicable laws and regulations. If you do not accept
            and agree to be bound by tProxiumAgreement in its entirety, you are
            strictly prohibited from visiting, accessing, registering with
            and/or using the Service or any information or Content provided
            through the Service, except as necessary to review tProxiumAgreement.
            The Service is continually under development, and we reserve the
            right to revise or remove any part of tProxiumAgreement or the Service
            in our sole discretion at any time and without prior notice to you.
            Any changes to tProxiumAgreement are effective upon posting to the
            Platform. Unless otherwise indicated, any new Content added to the
            Service is also subject to tProxiumAgreement upon posting to the
            Platform. If you disagree with tProxiumAgreement or any terms or
            conditions herein, your sole remedy is to discontinue your use of
            the Service. Your continued use after a change to tProxiumAgreement
            has been posted constitutes your acceptance of tProxiumAgreement as
            modified by such changes.
            <br />
            <br />
            <b>
              Your Relationship with Us
              <br />
            </b>
            We make available to individuals who register as users of the
            Service (“Users”) certain products and services sold or offered by
            Proxium or by third party medical providers, pharmacies, or other
            vendors via our Service. Our Service provides access to prescription
            fulfillment services offered by the following pharmacies: Postmeds,
            Inc. dba TruePill, EHT Pharmacy LLC dba Curexa, Apostrophe Pharmacy
            LLC, and XeCare LLC (the “Pharmacies”) and, from time to time, may
            offer laboratory services from the following laboratories: Rutgers
            Clinical Genomics Laboratory at RUCDR Infinite Biologics – Rutgers
            University (the “Labs”). You agree and understand that your
            prescription(s) may be filled by and transferred between any of the
            Pharmacies, and agree that the Service may do so on your behalf.{" "}
            <br />
            <br />
            We may also provide you with access to one or more of the following
            medical groups who provide healthcare and/or mental health services
            through the Platform (the “Medical Groups”): You Health of Alaska,
            P.C., You Health of California P.C., P.A., You Health of Hawaii,
            P.C., You Health of Kansas, P.A., You Health of Nebraska, P.C., You
            Health Williams of Nevada, P.C., You Health of New Jersey, P.C., and
            You Health of Texas, P.A. These medical groups employ or contract
            with physicians, allied health professionals, and mental health
            professionals who offer certain healthcare and/or mental health
            services through the Platform (“Providers”). By accepting
            tProxiumAgreement, you acknowledge and agree that any services you
            receive from the Labs, Pharmacies, Medical Groups or Providers
            through the Platform are also subject to tProxiumAgreement, and that
            the Labs, Pharmacies, Medical Groups and Providers are third party
            beneficiaries of tProxiumAgreement.
            <br />
            <br />
            We do not control or interfere with the practice of medicine or
            mental health care by the Medical Groups or any Providers, each of
            whom is solely responsible for directing the medical care, mental
            health care, and/or treatment they provide to you. By accepting
            tProxiumAgreement, you acknowledge and agree that Proxium is not a
            healthcare provider and that by using the Service, you are not
            entering into a doctor-patient or other health care provider-patient
            relationship with Proxium. By using the Service, you may, however, be
            entering into a doctor-patient or other health care provider-patient
            relationship with the Medical Group and/or one or more Providers.
            Further, we do not control or interfere with any professional
            service provided by the Labs and Pharmacies, each of which is solely
            responsible for their provision of professional services rendered
            via the Service.
            <br />
            <br />
            By accepting tProxiumAgreement, you acknowledge and agree that the
            Medical Group and/or Providers may send you messages, reports, and
            emails via the Service regarding your diagnosis and/or treatment.
            You understand and agree that Proxium is not responsible for the
            security or privacy of communications services you use to receive
            the aforementioned messages, reports, and emails sent via the
            Service. You further understand and agree that it is your sole
            responsibility to monitor and respond to these messages, reports,
            and emails and that neither Proxium nor the Medical Group nor any
            Provider will be responsible in any way and you will not hold Proxium,
            the Medical Group or any Provider liable for any loss, injury, or
            claims of any kind resulting from your failure to read or respond to
            these messages or for your failure to comply with any treatment
            recommendations or instructions from the Medical Group or your
            Provider(s).
            <br />
            <br />
            While you are not establishing a doctor-patient or other health care
            provider-patient relationship with Proxium, by using the Service, you
            are establishing a direct customer relationship with Proxium to use
            the Service, including the purchase of any non-prescription products
            or non-medical services sold directly to you by Proxium via the
            Service. In connection with such relationship, you may provide to
            us, or cause to be provided to us on your behalf, personal
            information, including health information, that is subject to use by
            us in accordance with our <u>Privacy Policy</u>. Please refer to the
            “Privacy Policy” section and the “Protected Information” section
            below for additional information.
            <br />
            <br />
            <b>
              Notice Regarding Your Financial Responsibility for Services
              <br />
            </b>
            Proxium and the Medical Groups are not enrolled with, and are not
            participating providers with, any federal or state healthcare
            programs (i.e., Medicare, Medicaid) for the provision of any health
            care or mental health services or supplies and, as such, neither you
            nor Proxium or the Medical Groups may receive payment from such
            programs for the services or products provided to you by Proxium or
            the Medical Groups. Further, to the extent that any of the Labs,
            Pharmacies, or Providers may be enrolled in federal or state
            healthcare programs, the means through which the services and
            products are provided or made accessible through the Service
            typically precludes such services and products from being covered
            benefits under these programs. By choosing to use the Service, you
            are specifically choosing to obtain products and services on a cash
            basis outside of any federal or state healthcare program. Thus, you
            are solely responsible for the costs of any service or product
            provided to you.
            <br />
            <br />
            By agreeing to use the Service, you acknowledge and agree that (1)
            you are explicitly choosing to obtain products and services on a
            cash basis outside of any federal or state healthcare program and
            you have sole financial responsibility for all services or products
            provided to you by or through the Service; and (2) neither you nor
            Proxium, the Labs, the Pharmacies, the Medical Groups or the Providers
            will submit a claim for reimbursement to any federal or state
            healthcare program for the costs of the services and products
            provided to you through the Service.
            <br />
            <br />
            <b>
              Subscription Products and Services
              <br />
            </b>
            Certain products and services available for purchase through the
            Service require that you purchase the product and/or service on an
            automatically renewing subscription basis. For subscription-based
            products and services, your payment device will be automatically
            charged at regular intervals as described for that product or
            service during the checkout process until you cancel your
            subscription. Your first renewal may be charged early to prevent any
            discontinuity in treatment. Your subsequent shipments may be charged
            and shipped up to two (2) days early to accommodate holidays or for
            other operational reasons to support continuity of treatment. We
            and/or the Providers may, but are not required to, perform outreach
            to you from time to time via the Service to request updates to your
            information and to facilitate ongoing subscriptions. You may cancel
            a subscription at any time by emailing support@Proxium.com and
            directly requesting a cancellation, or by calling 1-800-368-0038 to
            cancel, or through your online account. Cancellation will take
            effect at the end of the current subscription period. Your
            subscription will automatically renew for another subscription
            period unless you cancel at least two (2) days before the applicable
            renewal processing date of your subscription.
            <br />
            <br />
            We do not offer refunds for partially used subscription periods,
            although we may provide refunds on a case-by-case basis in our sole
            and absolute discretion. We may also offer you the ability to pause
            your subscription for a specified period of time. If you do not
            cancel before the end of the pause period, charging to your payment
            device will resume automatically. We may change our subscription
            plans and prices from time to time; however, we will provide you
            advance notice of any price changes or changes to your subscription
            plans.
            <br />
            <br />
            In order to simplify the user experience through the Service, you
            will only see and be required to pay a single “total” subscription
            price. However, if a subscription product you purchase required a
            consultation with a Provider, includes a prescription product that
            you fill through one of the Pharmacies and/or includes mental health
            services, then the total price you pay includes the amounts charged
            for use of the Service, as well as amounts charged by the Pharmacy
            for the prescription drug and the amount charged by the Medical
            Group for the services of the Provider, as applicable, which amounts
            are collected on behalf of and paid to the Pharmacies and Medical
            Groups, respectively.
            <br />
            <br />
            <b>
              Prescription Products
              <br />
            </b>
            Certain products available through the Platform require a valid
            prescription by a licensed healthcare provider. You will not be able
            to obtain a prescription product unless you have completed a
            consultation with one of the Providers, the Provider has determined
            the prescription product is appropriate for you and the Provider has
            written a prescription.
            <br />
            <br />
            If a Provider determines a prescription product is appropriate for
            you and writes a prescription, you will receive information about
            your options for filling the prescription. Certain prescriptions can
            be filled through one of the Pharmacies by using the Platform or you
            may fill the prescription at any pharmacy of your choice as prompted
            during your use of the Service or by emailing your request to
            support@Proxium.com. Prescriptions may also be transferred among the
            Pharmacies without notice. Not all prescriptions fulfilled by the
            Pharmacies use child-resistant packaging and your prescription
            product may not be dispensed in a child-resistant container.
            <br />
            <br />
            Some prescriptions are not available through the Pharmacies or must
            be filled by a local pharmacy of your choice as prompted during your
            use of the Service, including prescriptions used for many common
            primary care conditions.
            <br />
            <br />
            If you complete a consultation with a Provider and fill a
            prescription through one of the Pharmacies, the prescription product
            is shipped to you by the applicable Pharmacy and the costs
            associated with the prescription are included in the total charged
            to you by the Service as described in the “Subscription Products”
            section above. If you fill a prescription with a pharmacy other than
            the Pharmacies, the Service will send the prescription to your
            selected pharmacy, but you will be responsible for picking up or
            otherwise obtaining the prescription product and paying the pharmacy
            directly for the cost of the prescription product.
            <br />
            <br />
            Prescription products available through the Platform are
            “Third-Party Goods and Services” as described in the Third-Party
            Goods and Services section of tProxiumAgreement.
            <br />
            <br />
            <b>
              Laboratory Products and Services
              <br />
            </b>
            Certain laboratory products services available through the Platform,
            including at-home testing kits and services, require a valid
            prescription or order by a licensed healthcare provider. You will
            not be able to obtain such laboratory services unless you have
            completed a consultation with one of the Providers, the Provider has
            determined the laboratory product and/or service is appropriate for
            you and the Provider has prescribed or ordered the laboratory
            product and/or service.
            <br />
            <br />
            Currently, laboratory products and services offered through the
            Platform can only be ordered and fulfilled through the Labs and are
            not available through local laboratories. If you receive laboratory
            products and/or services from a Lab through the Platform, the
            applicable testing materials are shipped to you by the applicable
            Lab, and the costs associated with the laboratory products and
            services are included in the total charged to you by the Service.
            <br />
            <br />
            Laboratory products and services available through the Platform are
            “Third-Party Goods and Services” as described in the Third-Party
            Goods and Services section of tProxiumAgreement.
            <br />
            <br />
            <b>
              Limited Use and Availability
              <br />
            </b>
            Our Service is currently only available to individuals who are
            located in states in which we offer the Service, are at least
            eighteen (18) years of age or older, or at least the age of majority
            in their jurisdiction of residence, if higher than eighteen (18),
            and who have accepted tProxiumAgreement; provided, however, that
            individuals who are located in the states in which we offer the
            Service and are between the ages of 13 and 18 may use the Service
            for the sole purpose of obtaining a medical consultation for the
            treatment of acne using topical skincare products (to the extent
            available through the Service) if a parent or legal guardian
            provides consent to such use in accordance with the requirements set
            forth in tProxiumAgreement and the Service. By visiting, accessing,
            registering with or using the Service, you are (a) representing and
            warranting to us that you are either (1) at least eighteen (18)
            years of age or older or at least the age of majority in your
            jurisdiction of residence, if higher than eighteen (18), or (2) at
            least thirteen (13) years of age, have obtained consent from your
            parent or legal guardian to use the Service, and will use the
            Service for the sole purpose of obtaining a medical consultation for
            the treatment of acne; (b) if you are a parent or legal guardian
            providing consent for an individual minor who is under the age of
            eighteen (18) (or such higher age of majority under applicable state
            law), representing and warranting to us that you are the parent or
            legal guardian for such minor and have all legal power and authority
            to provide consent for the use of the Service by such minor; (c)
            representing and warranting to us that when you use the Service to
            consult with a Provider, you are located in the same state as the
            shipping address you provide in your account at the time that you
            conduct such consultation; (d) agreeing to comply with all
            applicable laws in visiting, accessing, registering with our using
            the service; and (e) agreeing that you will only use the Service for
            lawful purposes. <br />
            <br />
            Our Service is subject to state regulations and may change from time
            to time due to changes in applicable regulatory requirements.
            <br />
            <br />
            Certain products available through the Service are subject to
            additional age restrictions, and not all products or services are
            available to all ages.
            <br />
            <br />
            In some cases, the Service may not be the most appropriate way for
            you to provide information to, communicate with or seek medical
            and/or mental health care and treatment from a healthcare provider
            or mental health professional. For example, certain medical
            conditions may require an in-person procedure or a healthcare
            provider other than your Provider, or your Provider may determine
            that your diagnosis and/or treatment requires an in-person office
            visit or are otherwise not appropriately addressed through use of
            the Service. In such a case, you may receive notification that you
            will be unable to use the Service for the particular issue you
            submitted with additional information regarding next steps.
            <br />
            <br />
            <b>
              Consent to Use of Telehealth Services
              <br />
            </b>
            Telehealth involves the delivery of health and mental health care
            services using electronic communications, information technology or
            other means between a healthcare provider or mental health
            professional and a patient who are not in the same physical
            location. While the provision of health and mental health care
            services using telehealth may offer certain potential benefits,
            there are also potential risks associated with the use of
            telehealth. The telehealth services are not a substitute for
            in-person care in all cases. In order to use the Service, you will
            be required to review and agree to an informed consent regarding the
            use of telehealth (the “Patient Consent”) that will be provided to
            you via the Service. You agree that Proxium is a third party
            beneficiary of the Patient Consent and has the right to enforce it
            against you.
            <br />
            <br />
            <b>
              Duty to Provide Information, Access, and Connectivity
              <br />
            </b>
            You are responsible for providing and maintaining, at your own risk,
            option and expense, appropriate software and hardware capabilities
            (consistent with any technical, quality or other requirements
            described in the Service) to enable use of the Service, including
            but not limited to, a computer or mobile device with a video camera
            and Internet access. You are solely responsible for any fees,
            including Internet connection or mobile fees, that you incur when
            accessing the Service. You also have a duty to provide truthful,
            accurate and complete information in any forms or other
            communications you submit to or through the Service. We reserve the
            right to change the access configuration, including any software,
            hardware or other requirements of the Service at any time without
            prior notice. <br /> <br />
            <b>
              Privacy Policy
              <br />
            </b>
            Proxium understands the importance of confidentiality and privacy
            regarding your personal information. Please see our
            <u>Privacy Policy</u> for a description of how we may collect, use
            and disclose your personal information.
            <br />
            <br />
            <b>
              Protected Health Information
              <br />
            </b>
            When you set up an account with Proxium, you are creating a direct
            customer relationship with Proxium that enables you to access and/or
            utilize the various functions of the Service as a user. As part of
            that relationship, you provide information to Proxium, including but
            not limited to your name, email address, shipping address and phone
            number, that we may collect, use and disclose in accordance with our
            Privacy Policy, and that we do not consider to be “health” or
            “medical” information.
            <br />
            <br />
            However, in using certain components of the Service, you may also
            provide certain medical information that may be protected under
            applicable laws. Proxium is not a “covered entity” under the Health
            Insurance Portability and Accountability Act of 1996, Public Law
            104-191, and its related regulations and amendments from time to
            time (collectively, “HIPAA”). One or more of the Labs, Pharmacies or
            Medical Groups may or may not be a “covered entity” or “business
            associate” under HIPAA, and Proxium may in some cases be a “business
            associate” of a Lab, Pharmacy or Medical Group. It is important to
            remember that, while state-specific privacy laws may apply, HIPAA
            does not necessarily apply to an entity or person simply because
            there is health information involved, and HIPAA may not apply to
            your transactions or communications with Proxium, the Medical Groups,
            the Providers, the Labs, or the Pharmacies. To the extent Proxium is
            deemed a “business associate” however, and solely in its role as a
            business associate, Proxium, may be subject to certain provisions of
            HIPAA with respect to “protected health information,” as defined
            under HIPAA, that you provide to the Labs, Pharmacies, or Medical
            Groups (“PHI”). In addition, any medical or health information that
            you provide that is subject to specific protections under applicable
            state laws (collectively, with PHI, “Protected Information”), will
            be used and disclosed only in accordance with such applicable laws.
            However, any information that does not constitute Protected
            Information under applicable laws may be used or disclosed in any
            manner permitted under our Privacy Policy. Protected Information
            does not include information that has been de-identified in
            accordance with HIPAA.
            <br />
            <br />
            The Medical Groups and Providers have adopted a
            <u>Notice of Privacy Practices</u> that describes how they use and
            disclose Protected Information. By accessing or using any part of
            the Service, you are acknowledging receipt of the Notice of Privacy
            Practices from your Medical Group and Provider(s).
            <br />
            By using the Service, you are agreeing that even if HIPAA does apply
            to Proxium, the Medical Groups, the Providers, the Labs, or the
            Pharmacies, any information that you submit to Proxium that is not
            intended and used solely for the provision of diagnosis and
            treatment by the Medical Group and Providers or prescription
            fulfillment by the Pharmacies or laboratory services by the Labs, is
            not considered Protected Information, and will only be subject to
            our Privacy Policy and any applicable state laws that govern the
            privacy and security of such information.
            <br />
            <br />
            <b>
              Registration; User Accounts, Passwords, and Security
              <br />
            </b>
            You are obligated to register and set up an account in the Platform
            in order to access the Service, and the Service is available only to
            Users who have registered and have been granted accounts with
            usernames and passwords. For purposes of clarity, information you
            provide to Proxium in order to register and set up an account on the
            Platform, including name, username, email address, shipping address
            and phone number, are not considered Protected Information for
            purposes of the Protected Health Information section above. You
            agree to accurately maintain and update any information about
            yourself that you have provided to Proxium, a Medical Group or its
            Providers, the Labs or the Pharmacies. If you do not keep such
            information current, or fail to submit truthful, accurate and
            complete information, or we have reasonable grounds to suspect as
            much, we have the right to suspend or terminate your account and
            your use of the Service. You also agree to immediately notify Proxium
            of any unauthorized use of your username, password or any other
            breach of security that you become aware of involving or relating to
            the Service by emailing Proxium at support@Proxium.com. In addition, you
            agree to keep confidential your username and password and to exit
            from your User account at the end of each session. Proxium explicitly
            disclaims liability for any and all losses and damages arising from
            your failure to comply with tProxiumsection. You may not use anyone
            else’s account at any time.
            <br />
            <br />
            When establishing an account, you will be required to provide a
            username and password that will be used as your login for your
            account. To help protect the privacy of data you transmit through
            the Service, where personally identifiable information is requested,
            we also use technology designed to encrypt the information that you
            input before it is sent to us using Secure Sockets Layer (SSL)
            technology or similar encryption technology. In addition, we take
            steps to protect the User data we collect against unauthorized
            access. However, you should keep in mind that the Service and our
            services are run on software, hardware, and networks, any component
            of which may, from time to time, require maintenance or experience
            problems or breaches of security beyond our control. In addition,
            persons with access to your computer, phone, or other mobile or
            other devices may be able to access the Service and information
            about you, including medical information, contained in the Service.
            It is your responsibility to affirmatively logout from your account
            when you are not actively using it. It is also your responsibility
            to secure and prevent unauthorized physical access to your computer,
            phone and other devices, and to protect the confidentiality of your
            username and password.
            <br />
            <br />
            You must exercise caution, good sense, and sound judgment in using
            the Service. You are prohibited from violating, or attempting to
            violate, the security of the Service. Any such violations may result
            in criminal and/or civil penalties against you. Proxium may
            investigate any alleged or suspected violations and if a criminal
            violation is suspected, Proxium may cooperate with law enforcement
            agencies in their investigations.
            <br />
            <br />
            <b>
              Use and Ownership of the Service
              <br />
            </b>
            The Service and the information and Content available through the
            Service are protected by copyright laws throughout the world.
            Subject to tProxiumAgreement, Proxium grants you a limited,
            non-transferable, revocable license to access and use the Service
            for your personal use. Unless otherwise specified by Proxium in a
            separate license, your right to use any of the Service or the
            Content is subject to tProxiumAgreement and all rights in the Service
            and Content are reserved by Proxium. You agree that Proxium and its
            suppliers own all rights, title and interest in the Service
            (including but not limited to, any computer code, themes, objects,
            concepts, photographs, product descriptions, blog posts, artwork,
            animations, sounds, musical compositions, audiovisual effects,
            methods of operation, moral rights, and documentation). You will not
            remove, alter or obscure any copyright, trademark, service mark or
            other proprietary rights notices incorporated in or accompanying the
            Service. Proxium’ stylized name and other related graphics, logos,
            service marks and trade names used on or in connection with the
            Service are the trademarks of Proxium and may not be used without
            permission, including in connection with any third party products or
            services. Other trademarks, service marks and trade names that may
            appear on or in the Service are the property of their respective
            owners.
            <br />
            <br />
            <b>
              License to Information Submitted via the Service
              <br />
            </b>
            Subject to any limitations on Protected Information described below,
            any information you transmit to Proxium via the Service, whether by
            direct entry, submission, email or otherwise, including data,
            questions, comments, forum communications, or suggestions
            (collectively, “Submissions”), will, to the extent permitted under
            applicable law, be treated as non-confidential and non-proprietary.
            Subject to any applicable account settings that you select, you
            grant Proxium a fully paid, royalty-free, perpetual, irrevocable,
            worldwide, royalty-free, non-exclusive and fully sublicensable right
            (including any moral rights) and license to use, license,
            distribute, reproduce, modify, adapt, publicly perform, and publicly
            display, Submissions (in whole or in part) for the purposes of
            operating and providing the Service to you and to our other users.
            You warrant that the holder of any worldwide intellectual property
            right, including moral rights, in Submissions has completely and
            effectively waived all such rights and validly and irrevocably
            granted to you the right to grant the license stated above. You
            agree that you, not Proxium, are responsible for all of Submissions
            that you provide to the Service. In addition to the foregoing, Proxium
            shall have the right, in its sole discretion, to edit, duplicate, or
            alter the Submission in any manner for any purpose that Proxium deems
            necessary or desirable, and you irrevocably waive any and all
            so-called moral rights you may have in the Submission. You further
            agree that you shall have no right of approval and no claim to
            compensation in connection with the Submission.
            <br />
            <br />
            If a Submission you make contains Protected Information, Proxium’
            rights under tProxiumsection with respect to the use or disclosure of
            such Protected Information will be limited as and to the extent
            required under applicable law.
            <br />
            <br />
            <b>
              Prohibited Use
              <br />
            </b>
            You are prohibited from using or attempting to use the Service: (i)
            for any unlawful, unauthorized, fraudulent or malicious purpose;
            (ii) in any manner that could damage, disable, overburden, or impair
            any server, or the network(s) connected to any server; (iii) in any
            manner that could interfere with any other party’s use and enjoyment
            of the Service; (iv) to gain unauthorized access to any other
            accounts, computer systems, or networks connected to any server or
            systems through hacking, password mining or any other means; (v) to
            access systems, data, or information not intended by Proxium to be
            made accessible to a user; (vi) to obtain any materials, or
            information through any means not intentionally made available by
            Proxium; (vii) to reverse engineer, disassemble or decompile any
            section or technology on the Service; or (viii) for any use other
            than the business purpose for which it was intended.
            <br />
            In addition, in connection with your use of the Service, you agree
            you will not: (a) upload or transmit any message, information, data,
            text, software or images, or other content that is unlawful,
            harmful, threatening, abusive, harassing, tortious, defamatory,
            vulgar, obscene, libelous, or inappropriate with respect to race,
            gender, sexuality, ethnicity, or other intrinsic characteristic, or
            that may invade another’s right of privacy or publicity; (b) create
            a false identity or duplicative accounts for the purpose of
            misleading otProxium or impersonate any person or entity, including,
            without limitation, any Proxium representative, or falsely state or
            otherwise misrepresent your affiliation with a person or entity; (c)
            upload or transmit any material that you do not have a right to
            reproduce, display or transmit under any law or under contractual or
            fiduciary relationships (such as nondisclosure agreements); (d)
            upload files that contain viruses, trojan horses, worms, time bombs,
            cancel-bots, corrupted files, spyware or any other similar software
            or programs that may damage the operation of another’s computer or
            property of another; (e) delete any author attributions, legal
            notices or proprietary designations or labels that you upload to any
            communication feature; (f) use the Service’s communication features
            in a manner that adversely affects the availability of its resources
            to other users (e.g., excessive shouting, use of all caps, or
            flooding continuous posting of repetitive text); (g) upload or
            transmit any unsolicited advertising, promotional materials, “junk
            mail,” “spam,” “chain letters,” “pyramid schemes,” “phishing” or any
            other form of solicitation, commercial or otherwise; (h) violate any
            applicable local, state, national or international law; (i) upload
            or transmit any material that infringes any patent, trademark,
            service mark, trade secret, copyright or other proprietary rights of
            any party; (j) delete or revise any material posted by any other
            person or entity; (k) manipulate or otherwise display the Service by
            using framing, mirroring or similar navigational technology; (l)
            probe, scan, test the vulnerability of or breach the authentication
            measures of, the Service or any related networks or systems; (m)
            register, subscribe, attempt to register, attempt to subscribe,
            unsubscribe, or attempt to unsubscribe, any party for any services
            or any contests, promotions or sweepstakes if you are not expressly
            authorized by such party to do so; (n) harvest or otherwise collect
            information about otProxium, including email addresses; (o) use any
            robot, spider, scraper, or other automated or manual means to access
            the Service, or copy, download, distribute or reproduce any content
            or information on the Service; or (p) assist or permit any person in
            engaging in any of these activities.
            <br />
            <br />
            Proxium reserves the right to take whatever lawful actions it may deem
            appropriate in response to actual or suspected violations of the
            foregoing, including, without limitation, the suspension or
            termination of a User's access and/or account. Proxium may cooperate
            with legal authorities and/or third parties in the investigation of
            any suspected or alleged crime or civil wrong.
            <br />
            <br />
            Except as may be provided in the Privacy Policy or prohibited by
            applicable law, Proxium reserves the right, at all times, to disclose
            any information as Proxium deems necessary to satisfy any applicable
            law, regulation, legal process or governmental request, or to edit,
            refuse to post or to remove any information or materials, in whole
            or in part, in Proxium’ sole discretion.
            <br />
            <br />
            <b>
              Right to Monitor
              <br />
            </b>
            Proxium reserves the right to monitor general use of the Service at
            any time as it deems appropriate and to remove any materials that,
            in Proxium’ sole discretion, may be illegal, may subject Proxium to
            liability, may violate tProxiumAgreement, or are, in the sole
            discretion of Proxium, inconsistent with Proxium’ purpose for the
            Service.
            <br />
            <br />
            <b>
              Third-Party Goods and Services
              <br />
            </b>
            Parties other than Proxium, including Labs, Pharmacies, Medical Groups
            and Providers, provide services or sell products through the Service
            (collectively, “Third Parties”), and Proxium may also make available
            to you for purchase certain services, devices, items or products
            manufactured, distributed or sold by Third Parties (“Third-Party
            Goods and Services”). Your use of any Third-Party Goods and Services
            and any interactions with Third Parties, including payment and
            delivery of goods or services, and any other terms, conditions,
            warranties or representations associated with such use or
            interactions, are solely between you and such Third Parties. You
            should make whatever investigation you feel necessary or appropriate
            before proceeding with any online or offline transaction involving
            Third Parties or any Third-Party Goods and Services. You are solely
            responsible for, and shall exercise caution, discretion, common
            sense and judgment in, using the Service and disclosing personal
            information.
            <br />
            <br />
            You agree that Proxium shall not be responsible or liable for any loss
            or damage of any sort incurred as the result of your use of the
            Service, including any Third-Party Goods and Services or your
            interactions with any Third Parties. In the event of any dispute
            between you and any Third Party, any other User or any other entity
            or individual, you understand and agree that Proxium is under no
            obligation to become involved in such dispute, and you hereby
            release and indemnify Proxium, Apostrophe Pharmacy LLC, and XeCare
            LLC, and their respective corporate parents, subsidiaries, and
            affiliates, and all of their respective contractors, directors,
            officers, employees, representatives, proprietors, partners,
            shareholders, servants, principals, agents, predecessors,
            successors, assigns, accountants, and attorneys (collectively,
            “Proxium Parties”) from any and all claims, demands and/or damages
            (actual or consequential) of every kind or nature, known or unknown,
            suspected and unsuspected, disclosed or undisclosed, arising out of
            or in any way related to such disputes or the Service or the
            features and services therein.
            <br />
            <br />
            IF YOU ARE A CALIFORNIA RESIDENT, YOU WAIVE CALIFORNIA CIVIL CODE
            SECTION 1542, WHICH STATES: “A GENERAL RELEASE DOES NOT EXTEND TO
            CLAIMS THAT THE CREDITOR OR RELEASING PARTY DOES NOT KNOW OR SUSPECT
            TO EXIST IN ProxiumOR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE
            AND THAT, IF KNOWN BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED
            ProxiumOR HER SETTLEMENT WITH THE DEBTOR OR RELEASED PARTY.”
            <br />
            <br />
            Certain of Proxium’ shareholders, directors, officers, employees,
            contractors or agents (collectively, “Proxium Owners and Personnel”)
            may have a financial interest in one or more Third Parties and may
            profit from your use of the Third Parties and/or the sale of
            Third-Party Goods and Services to you.
            <br />
            <br />
            <b>
              Terms of Sale
              <br />
            </b>
            All products offered for sale by Proxium are subject to availability
            and we reserve the right to impose quantity limits on any order or
            reject all or any part of an order without prior notice. In the
            event of an error, we reserve the right to correct the error and
            revise your order accordingly (which includes charging the correct
            price) or to cancel the order and refund any amount charged. Prices
            for products are subject to change at any time. You are responsible
            for any applicable sales, use, duty, customs or other governmental
            taxes, levies or fees (“Taxes”) due with respect to your purchase of
            products or services through our Service. We will collect applicable
            Taxes if we determine we have a duty to collect Taxes. We will
            present an estimate of Taxes we collect at checkout, except where we
            have clearly stated in writing that a price includes Taxes. The
            actual Taxes charged may be adjusted from the amount shown at
            checkout. Several factors may cause this, such as variances between
            processor programs and changes in tax rates. We are not required to,
            and do not, collect Taxes in all states. You may have a duty to
            directly report and pay Taxes if we do not collect such Taxes.
            <br />
            <br />
            Only valid payment methods acceptable to us may be used to complete
            a purchase via the Service. You represent and warrant that you are
            authorized to use your designated payment method. You authorize us
            to charge your designated payment method for the total amount of
            your order (including any applicable taxes and shipping and handling
            charges). If your designated payment method is declined, we will
            attempt to process your charge until the transaction is approved. We
            and our third-party payment service providers may request, and may
            receive, updated payment card information from your payment card
            issuer, such as updated card numbers and expiration date information
            when your credit card has expired. If such updated information is
            provided to us and our third-party payment service providers, you
            agree we may update your account information accordingly, and will
            use such updated information to process payments for your future
            purchases and applicable subscription charges (including any
            applicable taxes, shipping and handling charges). Your payment card
            issuer may give you the right to opt out of providing vendors and
            third-party payment service providers with your updated card
            information. If you wish to opt out of your payment card’s updating
            service, you should contact your card issuer. We are not responsible
            for any fees or charges that your bank or payment card issuer may
            apply. If your bank or card issuer reverses a charge to your payment
            card, we may bill your account directly and seek payment by another
            method including a mailed statement.
            <br />
            <br />
            If any of the products in your order are unavailable, we will only
            charge the prices, Taxes and other applicable charges associated
            with the products that are included in the shipment. In connection
            with any purchase you make through the Service, you may be asked to
            supply certain information relevant to the transaction, including,
            without limitation, your payment card number and expiration date,
            your billing address, your shipping address, your phone number
            and/or your email address. By submitting such information, you grant
            Proxium without charge the irrevocable, unencumbered, universe-wide
            and perpetual right to provide such information (and any updated
            information we receive) to third parties (e.g., payment processing
            companies, buyers on the Service, sellers on the Service) for the
            purpose of facilitating the transaction.
            <br />
            <br />
            All credit card, debit card and other monetary transactions on or
            through the Service occur through an online payment processing
            application(s) accessible through the Service. TProxiumonline payment
            processing application(s) is provided by Proxium’ third-party online
            payment processing vendor, Stripe (“Stripe”). Additional information
            about Stripe, its privacy policy and its information security
            measures (collectively, the “Stripe Policies”) should be available
            on the Stripe website located at
            <u>https://stripe.com/us/privacy</u> or by contacting Stripe
            directly. Reference is made to the Stripe Policies for informational
            purposes only and are in no way incorporated into or made a part of
            tProxiumAgreement. Proxium’ relationship with Stripe, if any, is merely
            contractual in nature, as Stripe is nothing more than a third-party
            vendor to Proxium and is in no way subject to Proxium’ direction or
            control; thus, their relationship is not, and should not be
            construed as, one of fiduciaries, franchisors-franchisees,
            agents-principals, employers-employees, partners, joint venturers or
            the like.
            <br />
            <br />
            You agree to pay any shipping and handling charges, if any, shown at
            the time you make a purchase. We reserve the right to increase,
            decrease, add or eliminate shipping and handling charges from time
            to time, but we will provide notice of the changes applicable to you
            before you make your purchase. Any delivery dates or times shown as
            part of the checkout process are estimates only and are not
            guaranteed. Unless we state otherwise in writing via the Service,
            risk of loss or damage to a product passes to you upon delivery of
            the product to our designated carrier.
            <br />
            <br />
            We reserve the right to remedy User issues and concerns on a
            case-by-case basis. We reserve the right, in our sole discretion, to
            resolve customer issues and concerns based on the facts and
            circumstances of each User.
            <br />
            <br />
            <b>
              Termination
              <br />
            </b>
            Proxium may terminate your use of the Service or any of our features
            or services at any time and for any reason without notice,
            including, for example, for conduct violating tProxiumAgreement, if
            any or all of the agreements between Proxium and the Medical Groups,
            Labs, or Pharmacies terminate or if we discontinue the Service. The
            provisions of tProxiumAgreement concerning Service security,
            prohibited activities, copyrights, trademarks, user submissions,
            disclaimers, limitation of liability, arbitration and resolution of
            Disputes, indemnity and jurisdictional issues shall survive any such
            termination or any other termination of tProxiumAgreement or your
            relationship with Proxium. You agree that if your use of the Service
            is terminated pursuant to tProxiumAgreement, you will not attempt to
            use the Service under any name, real or assumed, and further agree
            that if you violate tProxiumrestriction after being terminated, you
            will indemnify and hold all Proxium Parties harmless from any and all
            liability that any such Proxium Parties may incur with respect
            thereto.
            <br />
            <br />
            Except as otherwise provided in the Privacy Policy or as required by
            applicable law (including any obligation to provide access to health
            records), we have no obligation, whether before or after the
            termination of your use of the Service, to return or otherwise
            provide to you or any third party on your behalf any Content, any
            information you provide to us, any information your Providers
            provided to us about or relating to you, or any other information
            that we may have that relates to you.
            <br />
            <br />
            <b>
              Disclaimers
              <br />
            </b>
            Content and other information contained on the Service is provided
            by Proxium as a convenience. Users relying on Content or other
            information from the Service do so at their own risk.
            <br />
            <br />
            THE SERVICE IS PROVIDED ON AN “AS IS” OR “AS AVAILABLE” BASIS. ANY
            ACCESS TO OR USE OF THE SERVICE IS VOLUNTARY AND AT THE SOLE RISK OF
            THE USER. Proxium AND EACH THIRD PARTY OFFERING PRODUCTS OR SERVICES
            THROUGH THE SERVICE, INCLUDING THE MEDICAL GROUPS, THE PROVIDERS,
            THE LABS, AND THE PHARMACIES, TO THE FULLEST EXTENT PERMITTED BY
            LAW, DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND, EITHER
            EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, WITHOUT
            LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY,
            NON-INFRINGEMENT OF THIRD PARTIES’ RIGHTS, SATISFACTORY QUALITY AND
            FITNESS FOR PARTICULAR PURPOSE WITH REGARD TO THE SERVICE, AND WITH
            RESPECT TO ANY INFORMATION, CONTENT, PRODUCT, SERVICE, MERCHANDISE
            OR OTHER MATERIAL PROVIDED ON OR THROUGH THE SERVICE OR THE
            PLATFORM. Proxium DOES NOT WARRANT OR GUARANTEE THE ACCURACY,
            COMPLETENESS, RELIABILITY, TIMELINESS OR USEFULNESS OF THE SERVICE.
            Proxium DOES NOT WARRANT THAT THE SERVICE WILL FUNCTION WITHOUT
            DELAYS, DISRUPTIONS, INTERFERENCES, IMPERFECTIONS, CORRUPTION, CYBER
            ATTACK, VIRUSES, MALWARE, OR ANY ADVERSE INCIDENT.
            <br />
            <br />
            <b>
              Limitation of Liability
              <br />
            </b>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            Proxium BE LIABLE TO YOU OR ANY OTHER PERSON OR ENTITY FOR ANY
            INCIDENTAL, INDIRECT, SPECIAL, EXEMPLARY AND CONSEQUENTIAL DAMAGES,
            PERSONAL OR BODILY INJURY, EMOTIONAL DISTRESS, OR WRONGFUL DEATH,
            LOSS OF DATA, LOST PROFITS, OR DAMAGES RESULTING FROM THE USE OF OR
            INABILITY TO USE THE SERVICE, INCLUDING ANY INFORMATION AND CONTENT
            MADE AVAILABLE THROUGH THE SERVICE OR ANY SERVICES PERFORMED OR
            PRODUCTS OFFERED BY THIRD PARTIES, WHETHER BASED ON WARRANTY,
            CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY,
            AND WHETHER OR NOT Proxium HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
            DAMAGES. Proxium SHALL BE LIABLE ONLY TO THE EXTENT OF ACTUAL DAMAGES
            INCURRED BY YOU, NOT TO EXCEED U.S. $1,000.
            <br />
            <br />
            ANY CLAIMS ARISING IN CONNECTION WITH YOUR USE OF THE SERVICE OR
            CONTENT MUST BE BROUGHT WITHIN ONE (1) YEAR OF THE DATE OF THE EVENT
            GIVING RISE TO SUCH ACTION OCCURRED.
            <br />
            <br />
            SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES
            OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR
            CONSEQUENTIAL DAMAGES. TO THE EXTENT THAT WE MAY NOT DISCLAIM ANY
            IMPLIED WARRANTY OR LIMIT ITS LIABILITIES, THE SCOPE AND DURATION OF
            SUCH WARRANTY AND THE EXTENT OF OUR LIABILITY WILL BE THE MINIMUM
            PERMITTED UNDER APPLICABLE LAW.
            <br />
            <br />
            <b>
              Indemnification
              <br />
            </b>
            You agree to defend, indemnify, and hold Proxium Parties and any Third
            Parties offering products or services through the Service, including
            the Medical Groups, Providers, Labs and Pharmacies, harmless from
            and against any and all suits, actions, claims, proceedings,
            damages, settlements, judgments, injuries, liabilities, obligations,
            losses, risks, costs, and expenses (including, without limitation,
            attorneys’ fees and litigation expenses) relating to or arising from
            your use of the Service, your fraud, violation of law, or willful
            misconduct, any breach by you of tProxiumAgreement or your violation
            of any rights of any other person or entity. We reserve the right to
            control the defense of any claim by a third party for which we are
            entitled to indemnification, and you agree to provide us with such
            cooperation as is reasonably requested by us.
            <br />
            <br />
            <b>
              Notices
              <br />
            </b>
            Any notices to you from Proxium regarding the Service or
            tProxiumAgreement may be made by email, a posted notice on the
            Service, or regular mail, in the sole discretion of Proxium.
            <br />
            <br />
            <b>
              Electronic Communications
              <br />
            </b>
            When you access or use the Service or send emails or SMS messages to
            us, any Medical Group or its Providers, you are communicating with
            us, the Medical Group and its Providers electronically. You consent
            to receive communications from us, the Medical Group and its
            Providers electronically. We will communicate with you via email,
            SMS messaging or through the Service. You agree that all agreements,
            notices, disclosures and other communications that we provide to you
            electronically satisfy any legal requirement that such
            communications be in writing. You further agree that any notices
            provided by us electronically are deemed to be given and received on
            the date we transmit any such electronic communication as described
            in tProxiumAgreement.
            <br />
            <br />
            <b>
              Copyright
              <br />
            </b>
            It is Proxium’ policy to terminate use of the Service by any User who
            repeatedly infringes copyright upon prompt notification to Proxium by
            the copyright owner or the copyright owner’s legal agent. Without
            limiting the foregoing, if you believe that your work has been
            copied and posted on the Service in a way that constitutes copyright
            infringement, please provide our Copyright Agent with the following
            information: (1) an electronic or physical signature of the person
            authorized to act on behalf of the owner of the copyright interest;
            (2) a description of the copyrighted work that you claim has been
            infringed; (3) a description of the location on the Service of the
            material that you claim is infringing; (4) your address, telephone
            number and e-mail address; (5) a written statement by you that you
            have a good faith belief that the disputed use is not authorized by
            the copyright owner, its agent or the law; and (6) a statement by
            you, made under penalty of perjury, that the above information in
            your notice is accurate and that you are the copyright owner or
            authorized to act on the copyright owner’s behalf. Contact
            information for Proxium’ Copyright Agent for notice of claims of
            copyright infringement is as follows: legal@Proxium.com.
            <br />
            <br />
            <b>
              Entire Agreement
              <br />
            </b>
            TProxiumAgreement and any other agreements Proxium may post on the
            Service or that you and Proxium may execute from to time constitute
            the entire agreement between Proxium and you in connection with your
            use of the Service and supersede any prior agreements between Proxium
            and you regarding use of the Service, including prior versions of
            tProxiumAgreement.
            <br />
            <br />
            <b>
              Binding Arbitration / Class Waiver
              <br />
            </b>
            YOU AND WE EXPRESSLY AGREE THAT ANY LEGAL CLAIM, DISPUTE OR OTHER
            CONTROVERSY BETWEEN YOU AND US OR ANY OF THE Proxium PARTIES, ANY
            MEDICAL GROUPS, PROVIDERS, LABS, OR PHARMACIES ARISING OUT OF OR
            OTHERWISE RELATING IN ANY WAY TO THE Proxium PARTIES, THE PLATFORM,
            THE CONTENT OR THE SERVICE, OR ANY OTHER GOODS, SERVICES OR
            ADVERTISING BY Proxium OR ANY OF THE Proxium PARTIES, LABS, PHARMACIES,
            MEDICAL GROUPS, OR PROVIDERS, INCLUDING CONTROVERSIES RELATING TO
            THE APPLICABILITY, ENFORCEABILITY OR VALIDITY OF ANY PROVISION OF
            TProxiumAGREEMENT (COLLECTIVELY, “DISPUTES”), THAT IS NOT RESOLVED BY
            AN INFORMAL DISPUTE RESOLUTION CONFERENCE (AS DEFINED AND DESCRIBED
            BELOW), SHALL BE RESOLVED IN CONFIDENTIAL BINDING ARBITRATION
            CONDUCTED BEFORE ONE COMMERCIAL ARBITRATOR FROM THE AMERICAN
            ARBITRATION ASSOCIATION (“AAA”), RATHER THAN IN A COURT, AS
            DESCRIBED HEREIN. <br />
            <br />
            THE ARBITRATION WILL BE GOVERNED BY THE AAA’S CONSUMER ARBITRATION
            RULES AND, IF THE ARBITRATOR DEEMS THEM APPLICABLE, THE
            SUPPLEMENTARY PROCEDURES FOR CONSUMER RELATED DISPUTES
            (COLLECTIVELY, “RULES AND PROCEDURES”). <br />
            <br />
            YOU ACKNOWLEDGE THAT YOU ARE VOLUNTARILY AND KNOWINGLY FORFEITING
            YOUR RIGHT TO A TRIAL BY JURY AND TO OTHERWISE PROCEED IN A LAWSUIT
            IN STATE OR FEDERAL COURT, EXCEPT AS EXPRESSLY PROVIDED HEREIN.{" "}
            <br />
            <br />
            FOR PURPOSES OF TProxiumARBITRATION AGREEMENT, “DISPUTE” WILL ALSO
            INCLUDE DISPUTES THAT AROSE OR INVOLVE FACTS OCCURING BEFORE THE
            EXISTENCE OF TProxiumOR ANY PRIOR VERSIONS OF THE TERMS AND CONDITIONS
            AS WELL AS CLAIMS THAT MAY ARISE AFTER THE TERMINATION OF THESE
            TERMS AND CONDITIONS.
            <br />
            <br />
            In the event a Dispute arises between us, we are committed to
            working with you to reach a reasonable resolution. You and we agree
            that good faith informal efforts to resolve Disputes can result in a
            prompt, low‐cost and mutually beneficial outcome. You and we
            therefore agree that before either party commences arbitration
            against the other (or initiates an action in small claims court if a
            party so elects), we will personally meet and confer telephonically
            or via videoconference, in a good faith effort to resolve informally
            any Dispute covered by tProxiumArbitration Agreement (“Informal
            Dispute Resolution Conference”). If you are represented by counsel,
            your counsel may participate in the conference, but you will also
            participate in the conference.
            <br />
            <br />
            The party initiating a Dispute must give notice to the other party
            in writing of its intent to initiate an Informal Dispute Resolution
            Conference (“Notice”), which shall occur within forty-five (45) days
            after the other party receives such Notice, unless an extension is
            mutually agreed upon by the parties. Notice to us that you intend to
            initiate an Informal Dispute Resolution Conference should be sent by
            email to legal@Proxium.com or regular mail to our offices located at
            2269 Chestnut Street #523, San Francisco, CA 94123. The Notice must
            include: (1) your name, telephone number, mailing address, e‐mail
            address associated with your account (if you have one); (2) the
            name, telephone number, mailing address and e‐mail address of your
            counsel, if any; and (3) a description of your Dispute. <br />
            <br />
            We will provide notice to your address on file. The Informal Dispute
            Resolution Conference shall be individualized such that a separate
            conference must be held each time either party initiates a Dispute,
            even if the same law firm or group of law firms represents multiple
            users in similar cases, unless all parties agree; multiple
            individuals initiating a Dispute cannot participate in the same
            Informal Dispute Resolution Conference unless all parties agree.
            <br />
            <br />
            If you and we are unable to resolve a Dispute within thirty (30)
            days after the applicable Informal Dispute Resolution Conference,
            either party may commence arbitration. Arbitration is more informal
            than a lawsuit in court. Arbitration uses a neutral arbitrator
            instead of a judge or jury, and court review of an arbitration award
            is very limited. However, an arbitrator can award the same damages
            and relief on an individual basis that a court can award to an
            individual.
            <br />
            Payment of arbitration costs will be governed by the AAA’s fee
            schedule. Each party agrees to pay its own attorneys’ fees and
            expenses unless there is a governing statutory provision that
            requires the prevailing party to be paid attorneys’ fees and
            expenses.
            <br />
            <br />
            The arbitration shall be conducted in San Francisco, California,
            except that, in the event San Francisco, California is not within
            one hundred (100) miles of your residence, the arbitration may be
            conducted within one hundred (100) miles of your residence, unless
            the parties agree otherwise in writing. The arbitrator’s award shall
            be final and binding on all parties and may be entered as a judgment
            in any court of competent jurisdiction. These Terms and Conditions
            evidence a transaction involving interstate commerce; and
            notwithstanding any other provision herein with respect to the
            applicable substantive law, the Federal Arbitration Act, 9 U.S.C. §
            1 et seq., will govern the interpretation and enforcement of
            tProxiumArbitration Agreement and any arbitration proceedings.
            <br />
            <br />
            For more information on AAA, its Rules and Procedures, and how to
            file an arbitration claim, you may call AAA at 800-778-7879 or visit
            the AAA website at <u>https://www.adr.org</u>.<br />
            <br />
            Notwithstanding anything to the contrary herein, to the extent the
            Dispute arises from: (a) a violation of either party’s intellectual
            property rights in any manner; and/or (b) any claim related to, or
            arising from, allegations of theft, piracy, unauthorized use or a
            violation of the Computer Fraud and Abuse Act; then you and the
            applicable Proxium Party agree that a party may seek injunctive
            remedies (or an equivalent type of urgent legal relief) in a state
            or federal court in San Francisco, California, and both parties
            agree to submit to the personal jurisdiction of such courts in
            connection with such proceedings. In addition to the foregoing,
            either you or we may assert an individual action in small claims
            court for Disputes that are within the scope of such court’s
            jurisdiction in lieu of arbitration as long as such action remains
            in such court and advances only on an individual (non-class,
            non-representative) basis.
            <br />
            <br />
            YOU AND WE HEREBY WAIVE ANY CONSTITUTIONAL AND STATUTORY RIGHTS TO
            SUE IN COURT AND HAVE A TRIAL IN FRONT OF A JUDGE OR A JURY. You and
            we are instead electing that all Disputes shall be resolved by
            arbitration under tProxiumArbitration Agreement, except as specified
            otherwise herein. There is no judge or jury in arbitration, and
            court review of an arbitration award is subject to very limited
            review.
            <br />
            YOU AND WE AGREE THAT, EXCEPT AS SPECIFIED HEREIN, ALL DISPUTES
            SUBJECT TO ARBITRATION UNDER TProxiumAGREEMENT MUST BE ARBITRATED ON
            AN INDIVIDUAL BASIS AND NOT ON A CLASS, COLLECTIVE OR REPRESENTATIVE
            BASIS. NO PARTY MAY BRING ANY CLAIM SUBJECT TO ARBITRATION PURSUANT
            TO TProxiumAGREEMENT AS A PRIVATE ATTORNEY GENERAL, IN A
            REPRESENTATIVE CAPACITY, OR AS A PLAINTIFF OR CLASS MEMBER IN ANY
            PURPORTED CLASS PROCEEDING. THE CLAIMS OF MORE THAN ONE CUSTOMER OR
            USER CANNOT BE JOINED OR CONSOLIDATED WITH THOSE OF ANY OTHER
            CUSTOMER OR USER. NO ARBITRATION SHALL BE CONSOLIDATED OR JOINED
            WITH ANY OTHER ARBITRATION EXCEPT AS SPECIFIED HEREIN. THE
            ARBITRATOR MAY AWARD RELIEF (INCLUDING MONETARY, INJUNCTIVE, AND
            DECLARATORY RELIEF) ONLY IN FAVOR OF THE INDIVIDUAL PARTY SEEKING
            RELIEF AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF
            NECESSITATED BY THAT PARTY’S INDIVIDUAL CLAIM(S). If a court decides
            by means of a final decision, not subject to any further appeal or
            recourse, that applicable law precludes enforcement of any of
            tProxiumparagraph’s limitations as to a particular claim or request
            for relief, then such claim or request for relief (and only that
            claim or request for relief) shall be severed from the arbitration
            and may be brought exclusively in the state or federal courts
            located in San Francisco, California, subject to the parties’
            respective rights to appeal the decision. All other claims or
            requests for relief shall be arbitrated. The parties agree that any
            claims or requests for relief that are severed from an arbitration
            may not proceed in litigation and shall be stayed until all claims
            between the parties remaining in arbitration are finally resolved.
            The parties agree to submit to the personal jurisdiction of the
            federal and state courts located in San Francisco, California for
            purposes of resolving any claims or requests for relief severed from
            arbitration pursuant to tProxiumparagraph. TProxiumsubsection does not
            prevent you or us from participating in a class-wide settlement of
            claims.
            <br />
            To increase the efficiency of administration and resolution of
            arbitrations, you and we agree that in the event that there are one
            hundred (100) or more individual arbitrations of a substantially
            similar nature filed against us by or with the assistance of the
            same law firm, group of law firms, or organizations, within a thirty
            (30) day period (or as soon as possible thereafter), the AAA shall
            (1) administer the arbitration demands in batches of one hundred
            (100) arbitrations per batch (plus, to the extent there are less
            than one hundred (100) arbitrations left over after the batching
            described above, a final batch consisting of the remaining
            arbitrations); (2) appoint one arbitrator for each batch; and (3)
            provide for the resolution of each batch as a single consolidated
            arbitration with one set of filing and administrative fees due per
            side per batch, one procedural calendar, one hearing (if any) in a
            place to be determined by the arbitrator, and one final award
            (“Batch Arbitration”).
            <br />
            All parties agree that arbitrations are of a “substantially similar
            nature” if they arise out of or relate to the same event, act,
            omission, practice or factual scenario and raise the same or similar
            legal issues and seek the same or similar relief. To the extent the
            parties disagree on the application of the Batch Arbitration
            process, the disagreeing party shall advise the AAA, and the AAA
            shall appoint a sole standing arbitrator to determine the
            applicability of the Batch Arbitration process (“Administrative
            Arbitrator”). In an effort to expedite resolution of any such
            dispute by the Administrative Arbitrator, the parties agree the
            Administrative Arbitrator may set forth such procedures as are
            necessary to resolve any disputes promptly. The Administrative
            Arbitrator’s fees shall be paid by us.
            <br />
            You and we agree to cooperate in good faith with the AAA to
            implement the Batch Arbitration process including the payment of
            single filing and administrative fees for batches of arbitrations,
            as well as any steps to minimize the time and costs of arbitration,
            which may include: (1) the appointment of a discovery special master
            to assist the arbitrator in the resolution of discovery disputes;
            and (2) the adoption of an expedited calendar of the arbitration
            proceedings. TProxiumBatch Arbitration provision shall in no way be
            interpreted as authorizing a class, collective and/or mass
            arbitration or action of any kind, or arbitration involving joint or
            consolidated claims under any circumstances, except as expressly set
            forth in tProxiumprovision.
            <br />
            You can opt out of the provisions of tProxiumArbitration agreement
            that require the arbitration of Disputes within thirty (30) days of
            the date that you first agree to any version of tProxiumAgreement that
            requires arbitration of disputes with Proxium or any of the Proxium
            Parties, Medical Groups, Labs, or Pharmacies. To opt out, you must
            send your name, residence address, and email address together with a
            clear statement that you want to opt out of the requirement to
            arbitrate disputes with the applicable party to: Proxium, 2269
            Chestnut Street, #523, San Francisco, CA 94123, ATTN: Arbitration
            Opt-Out. Opting out of tProxiumArbitration Agreement has no effect on
            any other arbitration agreements that you may currently have, or may
            enter in the future, with us or any other Proxium Parties.
            <br />
            Before you commence arbitration of a Dispute, you must provide us
            with a written Notice of Dispute that includes your name, residence
            address, username (if applicable) and email address associated with
            your User account (if applicable), a detailed description of the
            Dispute, and the relief you seek. Before we commence arbitration of
            a Dispute against you, we will provide a written Notice of Dispute
            to you with a detailed description of the Dispute and the relief we
            seek. Any Notice of Dispute you send to us should be mailed to
            Proxium, 2269 Chestnut Street, #523, San Francisco, CA 94123, ATTN:
            Dispute Notice. Notwithstanding anything to the contrary in
            tProxiumAgreement, if we make any future material modification to any
            provisions of tProxiumAgreement that govern the arbitration or
            resolution of Disputes, such changes will not apply to any Dispute
            between you and us for which either party had previously provided a
            written Notice of Dispute to the other in accordance with
            tProxiumparagraph. Further, if we make any future material changes to
            the provisions of tProxiumAgreement that govern the arbitration or
            resolution of Disputes, you may reject such changes by sending a
            written notice of your rejection decision to us at Proxium, 2269
            Chestnut Street, #523, San Francisco, CA 94123, ATTN: Arbitration
            Opt-Out within 30 days of the effective date of such modifications.
            Changes to tProxiumArbitration Agreement do not provide you with a new
            opportunity to opt out of the Arbitration Agreement if you have
            previously agreed to a version of these Terms and Conditions and did
            not validly opt out of arbitration. If you reject any change or
            update to tProxiumArbitration Agreement, and you were bound by an
            existing agreement to arbitrate Disputes, the provisions of
            tProxiumArbitration Agreement as of the date you first accepted the
            Terms and Conditions (or accepted any subsequent changes to these
            Terms and Conditions) remain in full force and effect. We will
            continue to honor any valid opt outs of the Arbitration Agreement
            that you made to a prior version of these Terms and Conditions.
            <br />
            Except as provided above, if any part or parts of tProxiumArbitration
            Agreement are found under the law to be invalid or unenforceable,
            then such specific part or parts shall be of no force and effect and
            shall be severed and the remainder of the Arbitration Agreement
            shall continue in full force and effect.
            <br />
            Governing Law; Venue; Severability of Provisions
            <br />
            TProxiumService is controlled and operated by Proxium from our offices
            within California. Those who choose to access the Service from other
            locations do so on their own initiative and are responsible for
            compliance with local laws, if and to the extent applicable. Access
            to the Service from jurisdictions where the contents of the Service
            are illegal or penalized is prohibited.
            <br />
            The validity, interpretation, construction and performance of
            tProxiumAgreement will be governed by the laws of the State of
            California, without regard to any conflicts of law provisions.
            <br />
            All parts of tProxiumAgreement apply to the maximum extent permitted
            by law. Our failure to enforce any provision of tProxiumAgreement will
            not constitute a waiver of such right. We both agree that if we
            cannot enforce a part of tProxiumAgreement as written, then that part
            will be replaced with terms that most closely match the intent of
            the unenforceable part to the extent permitted by law. Except as
            otherwise provided in tProxiumAgreement, the invalidity of part of
            tProxiumAgreement will not affect the validity and enforceability of
            the remaining provisions. The section headings are for convenience
            and do not have any force or effect.
            <br />
            No Agency Relationship
            <br />
            Neither tProxiumAgreement, nor any Content, materials or features of
            the Service create any partnership, joint venture, employment, or
            other agency relationship between you and Proxium, the Medical Groups,
            the Providers, the Labs or the Pharmacies. You may not enter into
            any contract on our behalf or bind us in any way.
            <br />
            Assignment
            <br />
            You may not assign any of your rights under tProxiumAgreement, and any
            such attempt will be null and void. Proxium may, in its sole
            discretion, assign or transfer, without further consent or
            notification, tProxiumAgreement or any or all of the contractual
            rights and obligations pursuant to tProxiumAgreement, in whole or in
            part, to any affiliate of Proxium or to a third party in the event
            that some or all of the business of Proxium is transferred to such
            other third party by way of merger, sale of its assets or otherwise.
            <br />
            Third Party Beneficiaries
            <br />
            Any use of third-party software provided in connection with the
            Service, or any Third-Party Goods and Services accessed or used in
            connection with the Service, will be governed by the applicable
            third-party’s license or terms of use, if any, and if there is no
            such license or terms of use, by tProxiumAgreement. In addition to
            tProxiumAgreement, your use of the Service must comply with all
            applicable third party terms of agreement, if any.
            <br />
            Except for the foregoing or as otherwise specifically set forth in
            tProxiumAgreement, including with respect to the indemnification
            obligations contained herein in favor of Proxium, the Medical Groups,
            the Pharmacies, the Labs, and the Providers and the agreement to
            arbitration, we hereby expressly agree that there is no intent by
            either party to create or establish third party beneficiary status
            rights or their equivalent in any other referenced individual,
            subcontractor or third party, and, except as specifically set forth
            in tProxiumAgreement, that no third party shall have any right to
            enforce any right or enjoy any benefit that is created or
            established under tProxiumAgreement.
            <br />
            Contacting Us
            <br />
            If you have any questions or concerns about tProxiumAgreement, please
            contact us by email at support@Proxium.com. We will attempt to respond
            to your questions or concerns promptly after we receive them.
          </p>
        </div>
      </div>
    </section>
  );
}
